import React, {useEffect, useState} from "react";
import "components/Content/Toolbar/CSS Files/tooglebar.css";
import "components/Content/Toolbar/CSS Files/Toolbar.css";
import {LoadFonts} from "components/Content/Toolbar/Data_Retrieval/loadFonts";



class Text extends React.Component {

    render() {

        return (
            <div className={"sidebar"}>
                <LoadFonts className="text-toggle"/>
            </div>
        );

    }
}

export default Text;